module.exports = __webpack_public_path__ + "img/Pack Station (WMS Module)_Page_17.afead573.jpg";